import styled from 'styled-components/macro'
import { flexRowNoWrap } from 'theme/styles'
import { Z_INDEX } from 'theme/zIndex'

export const HeaderWrapper = styled.div<{ transparent?: boolean }>`
  ${flexRowNoWrap};
  width: 100%;
  justify-content: space-between;
  position: fixed;
  top: 0;
  z-index: ${Z_INDEX.dropdown};
  background: rgba(0, 0, 0, 0.01);
  backdrop-filter: blur(30px);
  border-bottom: 1px solid rgba(97, 105, 113, 0.08);
`
